<template>
    <div class="flex w-full" v-if="this.loaded">
        <fs-nodes :current="current" @navigateTo="navigateTo" :show-info="showInfo" :filesystem="filesystem"
                  :selected="selected" @showInformation="showInfo = true" @hideInformation="showInfo = false"
                  @reload="reload" :can-upload="canUpload" @uploadingStarted="uploadStarted" :rotations="rotations"
                  @downloadNodesAsZip="downloadNodesAsZip"
                  @uploadingFinished="uploadFinished"
                  @toggleInfo="showInfo = !showInfo" :id="'fs-'+filesystemId" :prefs="prefs"
                  @setPrefs="setPrefs" ref="fsNodes"></fs-nodes>
    </div>
    <div v-else>
        <p class="text-xl text-gray-400 text-center font-semibold py-12" :id="'fs-'+filesystemId">Loading
            Filesystem...</p>
    </div>
</template>

<script>

import {Fs} from '@models'
import FsNodes from "./FsNodes.vue";
import './fs_dropzone.css';
import FsFile from "./FsFile.vue";
import User from "../../services/User";
import {uuid} from "../../utils";

export default {
    components: {FsFile, FsNodes},
    props: {
        filesystemId: String,
        path: String,
    },
    data() {
        let rotations = localStorage.getItem('node-rotations')
        rotations = rotations ? JSON.parse(rotations) : {key: 0}
        return {
            rotations: rotations,
            loaded: false,
            prefs: this.getPrefs(),
            filesystem: Object,
            current: null,
            showInfo: true,
            selected: [],
            canUpload: true,
            zipId: null,
        }
    },
    watch: {
        'current': {
            handler(a, b) {},
        },
    },
    computed: {},
    methods: {
        navigateTo(destination, toTop = true) {
            this.selected = [];
            this.current = destination ? destination : this.filesystem
            Fs.orderNodes(this.current.nodes, this.prefs)
            this.$forceUpdate()
            if (toTop) {
                this.$nextTick(() => {
                    const element = document.querySelector('#fs-' + this.filesystemId)
                    element.scrollIntoView(true)
                })
            }
        },
        reload() {
            Fs.orderNodes(this.filesystem.nodes, this.prefs)
            Fs.orderNodes(this.current.nodes, this.prefs)
            this.$forceUpdate()
        },
        getPrefs() {
            let prefs = localStorage.getItem('fs-preferences')
            prefs = prefs ? JSON.parse(prefs) : {
                foldersOnTop: true,
                sortBy: 'name',
                mode: 'list', // (can be list or icon)
                size: 'large', // (can be small,medium,large)
            }
            return prefs
        },
        setPrefs() {
            this.prefs.size = this.prefs.size ? this.prefs.size : 'large'
            this.filesystem.foldersOnTop = this.prefs.foldersOnTop
            this.filesystem.sortBy = this.prefs.sortBy
            this.filesystem.reorderNodes(this.prefs)
            Fs.orderNodes(this.current.nodes, this.prefs)
            if (this.foundNodes) {
                Fs.orderNodes(this.foundNodes, this.prefs)
            }
            localStorage.setItem('fs-preferences', JSON.stringify(this.prefs))
        },
        uploadStarted(id) {
            this.canUpload = id;
        },
        uploadFinished() {
            this.canUpload = true;
        },
        async updateFromListener(e) {
            eventBus.$emit('thumbnail-generated-' + e.data.filesystemId + '|' + e.data.fileId, e);
        },
        async zipGenerated(e) {
            if (e.data.zipId !== this.zipId) {
                return
            }
            this.$modals.close();
            if (this.waiting) {
                let a = document.createElement("a")
                document.body.appendChild(a)
                a.style = "display: none"
                a.href = route('api.v2.filesystem.zip', {'filesystem_id': this.filesystem.id, 'id': this.zipId})
                a.download = "download"
                a.click();
                document.body.removeChild(a)
            }
        },
        async zipProgressUpdated(e) {
            if (e.data.zipId !== this.zipId) {
                return
            }
            this.$modals.updateData({progress: e.data.percent})
        },
        async downloadNodesAsZip(nodes) {
            this.waiting = true;
            this.progress = 0;
            this.zipId = uuid();
            this.$modals.wait({
                title: 'Generating ZIP file...',
                useProgress: true,
                progress: this.progress,
                cancel: async () => {
                    await this.filesystem.abortZip(this.zipId)
                    this.$modals.close()
                    this.zipId = null;
                }
            })
            await this.filesystem.requestNodesAsZip(this.zipId, nodes).catch((response) => {
                this.$modals.close();
                alert(response.message)
            })
        },
    },
    async mounted() {
        User.registerAggregate({
            "type": 'Filesystem',
            'id': this.filesystemId,
            'event': 'ThumbnailGenerated'
        }, this.updateFromListener, true)
        User.registerAggregate({
            "type": 'Filesystem',
            'id': this.filesystemId,
            'event': 'ZipGenerated'
        }, this.zipGenerated, true)
        User.registerAggregate({
            "type": 'Filesystem',
            'id': this.filesystemId,
            'event': 'ZipProgressUpdated'
        }, this.zipProgressUpdated, true)

        this.filesystem = await Fs.find(this.filesystemId)
        this.filesystem.reorderNodes(this.prefs)
        this.current = this.filesystem
        this.loaded = true;
        if (this.path) {
            // attempt to goto the path if it exists
            let rec = function (parent, paths) {
                let pathMatrix = []
                let currentPath = []
                for (let i = 0; i < paths.length; i++) {
                    currentPath.push(paths[i])
                    pathMatrix.push(currentPath.join('/'));
                }
                for (let i = pathMatrix.length - 1; i >= 0; i--) {
                    let found = parent.nodes.find((n) => n.name === pathMatrix[i] && n.type === 'directory')
                    if (found) {
                        return rec(found, pathMatrix[pathMatrix.length - 1].slice(found.name.length + 1).split('/'))
                    }
                }
                return parent
            }
            let goto = rec(this.filesystem, this.path.split('/'));
            if (goto !== this.filesystem) {
                this.navigateTo(goto)
            }
        }
    }
}
</script>

